/* eslint-env browser */
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import apiMiddleware from './middleware/api';
import hookHandlerMiddleware from './middleware/hookHandler';
import rootReducer from './combined';

const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
      })
    : compose;

const enhancer = composeEnhancers(
  applyMiddleware(thunk, apiMiddleware, hookHandlerMiddleware)
);

const store = createStore(rootReducer, enhancer);

export default store;
